import { createTheme } from '@mui/material/styles';
import {themeOptions} from "./themeoption"

export default createTheme(themeOptions);
